import { useMutation } from '@tanstack/react-query';
import { businessAreasRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useEnableBusinessArea = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    businessAreasRepo.enableBusinessArea(id),
  );
